import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { tanimlarApi, isletmeApi } from '../services/api';
import axios from 'axios';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000';
const headers = () => ({ Authorization: `Bearer ${localStorage.getItem('token')}` });
const YIL = new Date().getFullYear();

export default function Dashboard() {
  const navigate = useNavigate();
  const [stats, setStats] = useState<any>(null);
  const [ozet, setOzet] = useState<any>(null);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [secilenYil, setSecilenYil] = useState(YIL);
  const [secilenAy, setSecilenAy] = useState(0);
  const [araziKayitlar, setAraziKayitlar] = useState<any[]>([]);
  const [varlikOzet, setVarlikOzet] = useState<any>(null);
  const [tarlaOzet, setTarlaOzet] = useState<any>(null);
  const [yemOzet, setYemOzet] = useState<any>(null);
  const [bahceOzet, setBahceOzet] = useState<any>(null);
  const [bitkiselDrill, setBitkiselDrill] = useState<string | null>(null);

  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  const isGM = user?.rol && ['super_admin', 'gm_yonetici', 'gm_personel'].includes(user.rol);

  const rolAd: Record<string, string> = {
    super_admin: 'Süper Yönetici', gm_yonetici: 'GM Yöneticisi',
    gm_personel: 'GM Personeli', isletme_mudur: 'İşletme Müdürü',
    isletme_personel: 'İşletme Personeli'
  };

  useEffect(() => {
    tanimlarApi.dashboard().then(r => setStats(r.data));
    isletmeApi.list(true).then(r => setIsletmeler(r.data));
  }, []);

  useEffect(() => {
    const params: any = { yil: secilenYil };
    if (secilenAy > 0) params.ay = secilenAy;
    axios.get(`${API}/api/tanimlar/dashboard/ozet`, { headers: headers(), params })
      .then(r => setOzet(r.data))
      .catch(() => setOzet(null));
    axios.get(`${API}/api/varlik/arazi`, { headers: headers(), params: { yil: secilenYil } })
      .then(r => setAraziKayitlar(r.data || []))
      .catch(() => setAraziKayitlar([]));
    axios.get(`${API}/api/varlik/ozet`, { headers: headers(), params: { yil: secilenYil } })
      .then(r => setVarlikOzet(r.data))
      .catch(() => setVarlikOzet(null));
    const bParams: any = { yil: secilenYil };
    if (secilenAy > 0) bParams.ay = secilenAy;
    setBitkiselDrill(null);
    axios.get(`${API}/api/bitkisel/tarla/ozet`, { headers: headers(), params: bParams })
      .then(r => setTarlaOzet(r.data)).catch(() => setTarlaOzet(null));
    axios.get(`${API}/api/bitkisel/yem/ozet`, { headers: headers(), params: bParams })
      .then(r => setYemOzet(r.data)).catch(() => setYemOzet(null));
    axios.get(`${API}/api/bitkisel/bahce/ozet`, { headers: headers(), params: bParams })
      .then(r => setBahceOzet(r.data)).catch(() => setBahceOzet(null));
  }, [secilenYil, secilenAy]);

  const n = (v: any) => Number(v || 0).toLocaleString('tr-TR');

  return (
    <div>
      <div className="page-header">
        <h1>TİGEM SGB</h1>
        <p>Hoş geldiniz, <strong>{user?.ad_soyad}</strong> — {rolAd[user?.rol] || user?.rol}</p>
      </div>

      {/* Üst özet kartları */}
      {isGM && (() => {
        const faalSayi    = isletmeler.filter(i => i.tip === 'Faal').length;
        const kiralikSayi = isletmeler.filter(i => i.tip === 'Kiralık').length;
        const isletmeMap: Record<number, string> = {};
        isletmeler.forEach(i => { isletmeMap[i.id] = i.tip || ''; });
        let toplamArazi = 0, faalArazi = 0, kiralikArazi = 0;
        araziKayitlar.forEach(r => {
          const da = r.toplam_arazi_da || 0;
          toplamArazi += da;
          if (isletmeMap[r.isletme_id] === 'Kiralık') kiralikArazi += da;
          else faalArazi += da;
        });
        return (
          <div className="stats-grid" style={{ marginBottom: 16 }}>
            <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/isletme-pano')}>
              <div className="stat-icon">🏢</div>
              <div>
                <div className="stat-value">{faalSayi}</div>
                <div className="stat-label">Faal İşletme</div>
                {kiralikSayi > 0 && <div style={{ fontSize: 11, color: '#e65100', marginTop: 2 }}>Kiralık: {kiralikSayi}</div>}
              </div>
            </div>
            <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/arazi')}>
              <div className="stat-icon">🗺️</div>
              <div>
                <div className="stat-value">{n(Math.round(toplamArazi))}</div>
                <div className="stat-label">Toplam Arazi (da)</div>
                <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
              </div>
            </div>
            <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/arazi')}>
              <div className="stat-icon">🏛️</div>
              <div>
                <div className="stat-value">{n(Math.round(faalArazi))}</div>
                <div className="stat-label">Faal İşletme Arazi (da)</div>
                <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
              </div>
            </div>
            <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/arazi')}>
              <div className="stat-icon">📋</div>
              <div>
                <div className="stat-value">{n(Math.round(kiralikArazi))}</div>
                <div className="stat-label">Kiralık İşletme Arazi (da)</div>
                <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
              </div>
            </div>
          </div>
        );
      })()}

      {/* Yıl seçici ve üretim özeti */}
      {isGM && (
        <>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 16, flexWrap: 'wrap' }}>
            <h2 style={{ fontSize: 16, color: '#1a5276', margin: 0 }}>📊 Üretim Özeti</h2>
            <select className="search-input" style={{ width: 90 }} value={secilenYil}
              onChange={e => { setSecilenYil(Number(e.target.value)); }}>
              {[2024, 2025, 2026].map(y => <option key={y} value={y}>{y}</option>)}
            </select>
            <select className="search-input" style={{ width: 120 }} value={secilenAy}
              onChange={e => setSecilenAy(Number(e.target.value))}>
              <option value={0}>Tüm Yıl</option>
              {['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık']
                .map((ad, i) => <option key={i+1} value={i+1}>{ad}</option>)}
            </select>
            {ozet && (
              <span style={{ fontSize: 12, color: '#888' }}>
                {secilenAy > 0
                  ? `${secilenYil} / ${['Ocak','Şubat','Mart','Nisan','Mayıs','Haziran','Temmuz','Ağustos','Eylül','Ekim','Kasım','Aralık'][secilenAy-1]} verisi`
                  : `${secilenYil} yılı toplamı`}
              </span>
            )}
          </div>

          {ozet ? (
            <>
              {/* Hayvancılık özet — satır 1: Büyükbaş grubu */}
              <div style={{ marginBottom: 4 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6, fontWeight: 'bold', textTransform: 'uppercase' }}>🐄 Hayvancılık</div>
                <div className="stats-grid">
                  <div className="stat-card" onClick={() => navigate('/isletme-pano?drill=buyukbas&yil=' + secilenYil + (secilenAy > 0 ? '&ay=' + secilenAy : ''))} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🐄</div>
                    <div>
                      <div className="stat-value">{n(ozet.buyukbas_toplam)}</div>
                      <div className="stat-label">Büyükbaş (Baş)</div>
                      {ozet.buyukbas_inek > 0 && <div style={{fontSize:11,color:'#888'}}>İnek: {n(ozet.buyukbas_inek)}</div>}
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/sut-uretimi')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🥛</div>
                    <div>
                      <div className="stat-value">{n(ozet.buyukbas_sut_kg)}</div>
                      <div className="stat-label">BB Süt Üretimi (kg)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/isletme-pano?drill=kucukbas&yil=' + secilenYil + (secilenAy > 0 ? '&ay=' + secilenAy : ''))} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🐑</div>
                    <div>
                      <div className="stat-value">{n(ozet.kucukbas_koyun)}</div>
                      <div className="stat-label">Koyun (Baş)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/isletme-pano?drill=kucukbas&yil=' + secilenYil + (secilenAy > 0 ? '&ay=' + secilenAy : ''))} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🐐</div>
                    <div>
                      <div className="stat-value">{n(ozet.kucukbas_keci)}</div>
                      <div className="stat-label">Keçi (Baş)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/sut-uretimi')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🥛</div>
                    <div>
                      <div className="stat-value">{n(ozet.kucukbas_sut_kg)}</div>
                      <div className="stat-label">KB Süt Üretimi (kg)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Hayvancılık özet — satır 2: At / Ceylan / Köpek / Arıcılık */}
              <div style={{ marginBottom: 8 }}>
                <div className="stats-grid">
                  <div className="stat-card" onClick={() => navigate('/isletme-pano?drill=at&yil=' + secilenYil + (secilenAy > 0 ? '&ay=' + secilenAy : ''))} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🐎</div>
                    <div>
                      <div className="stat-value">{n(ozet.at_toplam)}</div>
                      <div className="stat-label">At (Baş)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/asya-ceylani')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🦌</div>
                    <div>
                      <div className="stat-value">{n(ozet.ceylan_toplam)}</div>
                      <div className="stat-label">Asya Ceylanı (Baş)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/coban-kopegi')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🐕</div>
                    <div>
                      <div className="stat-value">{n(ozet.kopek_toplam)}</div>
                      <div className="stat-label">Çoban Köpeği (Baş)</div>
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                  <div className="stat-card" onClick={() => navigate('/aricilik')} style={{ cursor: 'pointer' }}>
                    <div className="stat-icon">🍯</div>
                    <div>
                      <div className="stat-value">{n(ozet.aricilik_kovan)}</div>
                      <div className="stat-label">Arıcılık (Kovan)</div>
                      {ozet.aricilik_bal_kg > 0 && <div style={{fontSize:11,color:'#888'}}>Bal: {n(ozet.aricilik_bal_kg)} kg</div>}
                      <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Bitkisel üretim özeti */}
              <div style={{ marginBottom: 16 }}>
                <div style={{ fontSize: 12, color: '#888', marginBottom: 6, fontWeight: 'bold', textTransform: 'uppercase' }}>🌾 Bitkisel Üretim — {secilenYil}</div>
                <div className="stats-grid">
                  <div className="stat-card" style={{ cursor: 'pointer', border: bitkiselDrill === 'tarla' ? '2px solid #1a5276' : undefined }}
                    onClick={() => setBitkiselDrill(bitkiselDrill === 'tarla' ? null : 'tarla')}>
                    <div className="stat-icon">🌾</div>
                    <div>
                      <div className="stat-value">{n(tarlaOzet?.toplam_ekim_da)}</div>
                      <div className="stat-label">Tarla Bitkileri (da)</div>
                      {tarlaOzet && <div style={{fontSize:12,color:'#555',marginTop:2}}>Hasat: {n(tarlaOzet.toplam_hasat_da)} da</div>}
                      <div style={{fontSize:11,color:'#777',marginTop:4}}>{bitkiselDrill === 'tarla' ? '▲ kapat' : '▼ detay'}</div>
                    </div>
                  </div>
                  <div className="stat-card" style={{ cursor: 'pointer', border: bitkiselDrill === 'yem' ? '2px solid #1a5276' : undefined }}
                    onClick={() => setBitkiselDrill(bitkiselDrill === 'yem' ? null : 'yem')}>
                    <div className="stat-icon">🌿</div>
                    <div>
                      <div className="stat-value">{n(yemOzet?.toplam_alan_da)}</div>
                      <div className="stat-label">Yem Bitkileri (da)</div>
                      {yemOzet && <div style={{fontSize:12,color:'#555',marginTop:2}}>Üretim: {n(yemOzet.toplam_uretim_kg)} kg</div>}
                      <div style={{fontSize:11,color:'#777',marginTop:4}}>{bitkiselDrill === 'yem' ? '▲ kapat' : '▼ detay'}</div>
                    </div>
                  </div>
                  <div className="stat-card" style={{ cursor: 'pointer', border: bitkiselDrill === 'bahce' ? '2px solid #1a5276' : undefined }}
                    onClick={() => setBitkiselDrill(bitkiselDrill === 'bahce' ? null : 'bahce')}>
                    <div className="stat-icon">🍎</div>
                    <div>
                      <div className="stat-value">{n(bahceOzet?.toplam_alan_da)}</div>
                      <div className="stat-label">Bahçe Kültürleri (da)</div>
                      {bahceOzet && <div style={{fontSize:12,color:'#555',marginTop:2}}>Üretim: {n(bahceOzet.toplam_uretim_kg)} kg</div>}
                      <div style={{fontSize:11,color:'#777',marginTop:4}}>{bitkiselDrill === 'bahce' ? '▲ kapat' : '▼ detay'}</div>
                    </div>
                  </div>
                </div>

                {/* Tarla drill-down */}
                {bitkiselDrill === 'tarla' && tarlaOzet && (
                  <div style={{ marginTop: 10, background: '#f0f4f8', borderRadius: 8, padding: 12 }}>
                    <div style={{ fontSize: 12, color: '#555', marginBottom: 8, fontWeight: 'bold' }}>🌾 Tarla Bitkileri Detayı</div>
                    <div className="stats-grid">
                      <div className="stat-card">
                        <div className="stat-icon">📐</div>
                        <div><div className="stat-value">{n(tarlaOzet.toplam_ekim_da)}</div><div className="stat-label">Ekim Alanı (da)</div></div>
                      </div>
                      <div className="stat-card">
                        <div className="stat-icon">✂️</div>
                        <div><div className="stat-value">{n(tarlaOzet.toplam_hasat_da)}</div><div className="stat-label">Hasat Alanı (da)</div></div>
                      </div>
                      {tarlaOzet.bugday_uretim_kg > 0 && (
                        <div className="stat-card">
                          <div className="stat-icon">🌾</div>
                          <div><div className="stat-value">{n(tarlaOzet.bugday_uretim_kg)}</div><div className="stat-label">Buğday (kg)</div></div>
                        </div>
                      )}
                      {tarlaOzet.arpa_uretim_kg > 0 && (
                        <div className="stat-card">
                          <div className="stat-icon">🌱</div>
                          <div><div className="stat-value">{n(tarlaOzet.arpa_uretim_kg)}</div><div className="stat-label">Arpa (kg)</div></div>
                        </div>
                      )}
                      {tarlaOzet.yulaf_uretim_kg > 0 && (
                        <div className="stat-card">
                          <div className="stat-icon">🌿</div>
                          <div><div className="stat-value">{n(tarlaOzet.yulaf_uretim_kg)}</div><div className="stat-label">Yulaf (kg)</div></div>
                        </div>
                      )}
                      {tarlaOzet.tritikale_uretim_kg > 0 && (
                        <div className="stat-card">
                          <div className="stat-icon">🌿</div>
                          <div><div className="stat-value">{n(tarlaOzet.tritikale_uretim_kg)}</div><div className="stat-label">Tritikale (kg)</div></div>
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop: 8, textAlign: 'right' }}>
                      <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => navigate('/tarla')}>Tarla Bitkileri Sayfası →</button>
                    </div>
                  </div>
                )}

                {/* Yem drill-down */}
                {bitkiselDrill === 'yem' && yemOzet && (
                  <div style={{ marginTop: 10, background: '#f0f8f0', borderRadius: 8, padding: 12 }}>
                    <div style={{ fontSize: 12, color: '#555', marginBottom: 8, fontWeight: 'bold' }}>🌿 Yem Bitkileri Detayı</div>
                    <div className="stats-grid">
                      <div className="stat-card">
                        <div className="stat-icon">📐</div>
                        <div><div className="stat-value">{n(yemOzet.toplam_alan_da)}</div><div className="stat-label">Toplam Alan (da)</div></div>
                      </div>
                      <div className="stat-card">
                        <div className="stat-icon">🌿</div>
                        <div><div className="stat-value">{n(yemOzet.toplam_uretim_kg)}</div><div className="stat-label">Üretim (kg)</div></div>
                      </div>
                      {yemOzet.toplam_tohum_ton > 0 && (
                        <div className="stat-card">
                          <div className="stat-icon">🌱</div>
                          <div><div className="stat-value">{n(yemOzet.toplam_tohum_ton)}</div><div className="stat-label">Tohum Üretimi (ton)</div></div>
                        </div>
                      )}
                    </div>
                    <div style={{ marginTop: 8, textAlign: 'right' }}>
                      <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => navigate('/yem')}>Yem Bitkileri Sayfası →</button>
                    </div>
                  </div>
                )}

                {/* Bahçe drill-down */}
                {bitkiselDrill === 'bahce' && bahceOzet && (
                  <div style={{ marginTop: 10, background: '#fff8f0', borderRadius: 8, padding: 12 }}>
                    <div style={{ fontSize: 12, color: '#555', marginBottom: 8, fontWeight: 'bold' }}>🍎 Bahçe Kültürleri Detayı</div>
                    <div className="stats-grid">
                      <div className="stat-card">
                        <div className="stat-icon">📐</div>
                        <div><div className="stat-value">{n(bahceOzet.toplam_alan_da)}</div><div className="stat-label">Toplam Alan (da)</div></div>
                      </div>
                      <div className="stat-card">
                        <div className="stat-icon">🍎</div>
                        <div><div className="stat-value">{n(bahceOzet.toplam_uretim_kg)}</div><div className="stat-label">Üretim (kg)</div></div>
                      </div>
                    </div>
                    <div style={{ marginTop: 8, textAlign: 'right' }}>
                      <button className="btn btn-secondary" style={{ fontSize: 12 }} onClick={() => navigate('/bahce')}>Bahçe Kültürleri Sayfası →</button>
                    </div>
                  </div>
                )}
              </div>

              {/* Varlık Yönetimi özeti */}
              {varlikOzet && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, color: '#888', marginBottom: 6, fontWeight: 'bold', textTransform: 'uppercase' }}>🏗️ Varlık Yönetimi ({secilenYil})</div>
                  <div className="stats-grid">
                    <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/arazi')}>
                      <div className="stat-icon">🗺️</div>
                      <div>
                        <div className="stat-value">{n(Math.round(varlikOzet.toplam_arazi_da))}</div>
                        <div className="stat-label">Toplam Arazi (da)</div>
                        {varlikOzet.sulanan_arazi_da > 0 && <div style={{fontSize:11,color:'#888'}}>Sulanan: {n(Math.round(varlikOzet.sulanan_arazi_da))} da</div>}
                        <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                      </div>
                    </div>
                    <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/makine')}>
                      <div className="stat-icon">🚜</div>
                      <div>
                        <div className="stat-value">{n(varlikOzet.traktor_adet)}</div>
                        <div className="stat-label">Traktör (adet)</div>
                        {varlikOzet.traktor_guc_kw > 0 && <div style={{fontSize:11,color:'#888'}}>Güç: {n(varlikOzet.traktor_guc_kw)} KW</div>}
                        <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                      </div>
                    </div>
                    <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/tasit')}>
                      <div className="stat-icon">🚗</div>
                      <div>
                        <div className="stat-value">{n(varlikOzet.toplam_tasit)}</div>
                        <div className="stat-label">Toplam Taşıt (adet)</div>
                        <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                      </div>
                    </div>
                    <div className="stat-card" style={{ cursor: 'pointer' }} onClick={() => navigate('/tesis')}>
                      <div className="stat-icon">🏭</div>
                      <div>
                        <div className="stat-value">{n(Math.round(varlikOzet.silo_ton))}</div>
                        <div className="stat-label">Silo Kapasitesi (ton)</div>
                        {varlikOzet.buyukbas_barinagi_bas > 0 && <div style={{fontSize:11,color:'#888'}}>BB Barınak: {n(varlikOzet.buyukbas_barinagi_bas)} baş</div>}
                        <div style={{fontSize:10,color:'#aaa',marginTop:2}}>detay →</div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {ozet.buyukbas_toplam === 0 && ozet.kucukbas_koyun === 0 && ozet.bitkisel_ekim_da === 0 && (
                <div className="card" style={{ textAlign: 'center', color: '#999', padding: 20 }}>
                  <p>{secilenYil} yılı için henüz veri girilmemiş. Modüllere veri girerek dashboard'u doldurun.</p>
                </div>
              )}
            </>
          ) : (
            <div className="card" style={{ textAlign: 'center', color: '#999', padding: 20 }}>Yükleniyor...</div>
          )}
        </>
      )}


      {/* İşletmeler tablosu */}
      {isGM && (
        <div className="card">
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 8 }}>
            <h2 style={{ margin: 0 }}>📍 TİGEM Tarım İşletmeleri</h2>
            <button className="btn btn-primary" style={{ fontSize: 12, padding: '6px 14px' }}
              onClick={() => navigate('/isletme-pano')}>
              📊 İşletme Panosu
            </button>
          </div>
          <div className="table-container">
            <table>
              <thead>
                <tr><th>Kod</th><th>İşletme Adı</th><th>İl</th><th>İlçe</th><th>Müdür</th><th>Tür</th></tr>
              </thead>
              <tbody>
                {/* Faal İşletmeler */}
                {isletmeler.filter(i => i.tip === 'Faal').length > 0 && (
                  <tr><td colSpan={6} style={{ background: '#e8f5e9', fontWeight: 600, color: '#2e7d32', fontSize: 13, padding: '8px 12px' }}>Faal İşletmeler ({isletmeler.filter(i => i.tip === 'Faal').length})</td></tr>
                )}
                {isletmeler.filter(i => i.tip === 'Faal').map(i => (
                  <tr key={i.id}>
                    <td><strong>{i.kod}</strong></td>
                    <td><a href="#" onClick={e => { e.preventDefault(); navigate(`/isletme-pano?isletme=${i.id}`); }}
                      style={{ color: '#1a5276', fontWeight: 500, textDecoration: 'underline', cursor: 'pointer' }}>{i.ad}</a></td>
                    <td>{i.il}</td>
                    <td>{i.ilce || '-'}</td>
                    <td>{i.mudur || '-'}</td>
                    <td><span className="badge badge-aktif">Faal</span></td>
                  </tr>
                ))}
                {/* Kiralık İşletmeler */}
                {isletmeler.filter(i => i.tip === 'Kiralık').length > 0 && (
                  <tr><td colSpan={6} style={{ background: '#fff3e0', fontWeight: 600, color: '#e65100', fontSize: 13, padding: '8px 12px' }}>Kiralık İşletmeler ({isletmeler.filter(i => i.tip === 'Kiralık').length})</td></tr>
                )}
                {isletmeler.filter(i => i.tip === 'Kiralık').map(i => (
                  <tr key={i.id} style={{ opacity: 0.8 }}>
                    <td><strong>{i.kod}</strong></td>
                    <td><a href="#" onClick={e => { e.preventDefault(); navigate(`/isletme-pano?isletme=${i.id}`); }}
                      style={{ color: '#1a5276', fontWeight: 500, textDecoration: 'underline', cursor: 'pointer' }}>{i.ad}</a></td>
                    <td>{i.il}</td>
                    <td>{i.ilce || '-'}</td>
                    <td>{i.mudur || '-'}</td>
                    <td><span style={{ background: '#fff3e0', color: '#e65100', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>Kiralık</span></td>
                  </tr>
                ))}
                {/* Merkez */}
                {isletmeler.filter(i => i.tip === 'Merkez').length > 0 && (
                  <tr><td colSpan={6} style={{ background: '#e3f2fd', fontWeight: 600, color: '#1565c0', fontSize: 13, padding: '8px 12px' }}>Merkez ({isletmeler.filter(i => i.tip === 'Merkez').length})</td></tr>
                )}
                {isletmeler.filter(i => i.tip === 'Merkez').map(i => (
                  <tr key={i.id}>
                    <td><strong>{i.kod}</strong></td>
                    <td><a href="#" onClick={e => { e.preventDefault(); navigate(`/isletme-pano?isletme=${i.id}`); }}
                      style={{ color: '#1a5276', fontWeight: 500, textDecoration: 'underline', cursor: 'pointer' }}>{i.ad}</a></td>
                    <td>{i.il}</td>
                    <td>{i.ilce || '-'}</td>
                    <td>{i.mudur || '-'}</td>
                    <td><span style={{ background: '#e3f2fd', color: '#1565c0', padding: '2px 8px', borderRadius: 4, fontSize: 12 }}>Merkez</span></td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {!isGM && (
        <div className="card">
          <h2>📋 Bilgi Paneli</h2>
          <p style={{ color: '#666', fontSize: 14 }}>Sol menüden ilgili modüle geçiş yaparak veri girişi yapabilirsiniz.</p>
        </div>
      )}
    </div>
  );
}
